import { useCallback, useSyncExternalStore } from 'react';

/**
 * ВСПЛЫТИЕ И ЗВУК ОТКЛЮЧАЕМЫ (`s720`, слова задания). Настройка — этого человека в этом браузере:
 * одна на все его вкладки (уведомление и звук тоже одни на все вкладки), другому сотруднику на том
 * же компьютере она не достаётся. Хранилище закрыто — оба включены, как по умолчанию.
 */
export interface NastroykiUvedomleniy {
  vsplytie: boolean;
  zvuk: boolean;
}

const PO_UMOLCHANIYU: NastroykiUvedomleniy = { vsplytie: true, zvuk: true };
const klyuch = (userId: number) => `opsmind.uvedomleniya.v1.${userId}`;
const slushateli = new Set<() => void>();
const kesh = new Map<number, { syroe: string | null; znachenie: NastroykiUvedomleniy }>();

export function prochitatNastroyki(userId: number): NastroykiUvedomleniy {
  let syroe: string | null;
  try {
    syroe = window.localStorage.getItem(klyuch(userId));
  } catch {
    return PO_UMOLCHANIYU;
  }

  // Один и тот же объект на одно и то же значение — иначе экран перерисовывался бы без конца.
  const bylo = kesh.get(userId);
  if (bylo !== undefined && bylo.syroe === syroe) return bylo.znachenie;

  let znachenie = PO_UMOLCHANIYU;
  if (syroe !== null) {
    try {
      const d = JSON.parse(syroe) as Partial<NastroykiUvedomleniy>;
      znachenie = { vsplytie: d.vsplytie !== false, zvuk: d.zvuk !== false };
    } catch {
      znachenie = PO_UMOLCHANIYU;
    }
  }
  kesh.set(userId, { syroe, znachenie });

  return znachenie;
}

export function zapisatNastroyki(userId: number, novye: NastroykiUvedomleniy): void {
  try {
    window.localStorage.setItem(klyuch(userId), JSON.stringify(novye));
  } catch {
    // Хранилище закрыто — настройка не запомнится; уведомления остаются включёнными.
  }
  slushateli.forEach((s) => s());
}

function podpisatsya(slushatel: () => void): () => void {
  slushateli.add(slushatel);
  // Другая вкладка сменила настройку — эта узнаёт сразу.
  window.addEventListener('storage', slushatel);

  return () => {
    slushateli.delete(slushatel);
    window.removeEventListener('storage', slushatel);
  };
}

export function useNastroykiUvedomleniy(userId: number | null): [NastroykiUvedomleniy, (pravka: Partial<NastroykiUvedomleniy>) => void] {
  const znachenie = useSyncExternalStore(podpisatsya, () => (userId === null ? PO_UMOLCHANIYU : prochitatNastroyki(userId)));
  const zapisat = useCallback((pravka: Partial<NastroykiUvedomleniy>) => {
    if (userId !== null) zapisatNastroyki(userId, { ...prochitatNastroyki(userId), ...pravka });
  }, [userId]);

  return [znachenie, zapisat];
}
